import { Component, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { AppleApplication } from '@rocksoft/mdm-sdk-v2';

import { NgbDropdownButtonItem, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AsyncPipe } from '@angular/common';
import { VppApplicationsStoreSelectors } from '@era/stores';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { ContextMenuComponent, PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';
import { AppleApplicationsService } from '../../shared/services/apple-application.service';
import { RemoveApplicationModalComponent } from './remove-application-modal/remove-application-modal.component';
import { UploadApplicationModalComponent } from './upload-application-modal/upload-application-modal.component';

@Component({
  selector: 'ml-mdm-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss'],
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    FaIconComponent,
    AsyncPipe,
  ],
})
export class ApplicationsComponent implements OnInit {
  private readonly applicationsService = inject(AppleApplicationsService);
  private readonly modalService = inject(NgbModal);
  private readonly store = inject(Store);

  public editMode = false;
  public applications: Observable<AppleApplication[]>;
  public vppApplications = this.store.selectSignal(VppApplicationsStoreSelectors.selectAllVppApplications);
  public app: AppleApplication;

  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  selectApp(app: AppleApplication) {
    this.app = app;
  }

  removeApp(app: AppleApplication) {
    this.applicationsService.deleteApplication(app.bundleIdentifier, app.bundleVersion);
    this.toggleEditMode();
  }

  public showUploadApplicationModal() {
    this.modalService.open(UploadApplicationModalComponent, { scrollable: true, size: 'xl' });
  }

  public openRemoveApplicationModal(app: AppleApplication) {
    const modal = this.modalService.open(RemoveApplicationModalComponent, { scrollable: true, size: 'xl' });
    modal.componentInstance.app = app;
  }

  ngOnInit() {
    this.applications = this.applicationsService.applications;
  }
}
